import { Component } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Title } from '@angular/platform-browser';

import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Subscription, Observable } from 'rxjs';

import { ForgotPasswordDialog } from './forgot-password';
import { RegistrationDialog } from './registration';
import { LoginDialog } from './login';
import { CompanyService, CompanyModel } from '../../../resource-module'

@Component({
	selector: 'landing',
	templateUrl: './landing.component.html',
	styleUrls: ['./landing.component.scss']
})
export class LandingComponent {

	public urlStub: string = '';
	protected _dialogRef: MatDialogRef<any>;
    protected _dialogSubscription: Subscription;
	public pending: boolean = false;
	private code: string = '';
	private role: string = '';
	public invite: boolean = false;
	private company: CompanyModel | null = null;

	public customerId: string | null = null;

    constructor(
		private route: ActivatedRoute,
		protected _dialog: MatDialog,
		protected companyService: CompanyService
    ) {
		this.route.paramMap.subscribe(params => {
			// TODO: Better way to choose a default
			this.code = params.get('code');
			this.role = this.route.snapshot.queryParams['r'];
			this.invite = this.route.snapshot.queryParams['i'] == 'true';
			this.customerId = this.route.snapshot.queryParams['c'];

			let query: object = {};

			if(this.code) {
				query = {
					"query": {
						"term": {
							"code.keyword": this.code
						}
					}
				};
			} else {
				query = {
					"query": {
						"term": {
							"isDefault": true
						}
					}
				};
			}
			this.companyService.search(query).subscribe((response) => {
				if(response.results.length > 0) {
					this.company = response.results[0];
					this.code = this.company.code;
					if(this.code && this.invite) {
						this._dialogRef = this._dialog.open(RegistrationDialog, {
							data: {
								code: this.code,
								role: this.role,
								company: this.company,
								customerId: this.customerId
							}
						});

						this._dialogSubscription = this._dialogRef.afterClosed().subscribe((token: string) => {
							if (token) {
							} else {
								this._dialogSubscription.unsubscribe();
							}
						});
					}
				} else {
					//this.message = "Invalid company code.";
				}
			})
		});
    }


	public register(username: string = "") {

		this._dialogRef = this._dialog.open(RegistrationDialog, {
			data: {
				code: this.code,
				//role: this.role,
				company: this.company,
				step: username ? 1 : 0,
				username: username
			}
		});

		this._dialogSubscription = this._dialogRef.afterClosed().subscribe((data: any) => {
			if(data && data.sendToLogin) {
				this.login(data.message);
			} else {
				this._dialogSubscription.unsubscribe();
			}
		});
	}

	public login(message: string = "") {

		this._dialogRef = this._dialog.open(LoginDialog, {
			data: {message: message}
		});

		this._dialogSubscription = this._dialogRef.afterClosed().subscribe((data: any) => {
			if (data && data.sendToForgot) {
				this._dialogSubscription.unsubscribe();
				this.forgotPassword();
			} else if(data && data.sendToVerification) {
				this._dialogSubscription.unsubscribe();
				this.register(data.username);
			} else {
				this._dialogSubscription.unsubscribe();
			}
		});
	}

	public forgotPassword() {
		this._dialogRef = this._dialog.open(ForgotPasswordDialog, {
			data: {}
		});

		this._dialogSubscription = this._dialogRef.afterClosed().subscribe((data: any) => {
			if (data && data.sendToLogin) {
				this._dialogSubscription.unsubscribe();
				this.login(data.message);
			} else {
				this._dialogSubscription.unsubscribe();
			}
		});
	}
}
